import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
const byId = state => state.entities.inspection.byId;
const formDataById = state => state.entities.formData.byId;
const formSchemaById = state => state.entities.formSchema.byId;
const uiSchemaById = state => state.entities.uiSchema.byId;
const validatorSchemaById = state => state.entities.validatorSchema.byId;
const availableFilters = state => state.entities.inspection.availableFilters;

export const getInspectionById = createSelector(
  byId,
  formDataById,
  formSchemaById,
  uiSchemaById,
  validatorSchemaById,
  (state, id) => id,
  (inspections, formDatas, formSchemas, uiSchemas, validatorSchemas, id) => {
    if (isEmpty(inspections)) return {};
    let inspection = inspections[id];
    const formData = inspection && inspection.formData ? formDatas[inspection.formData] : {};
    if (isEmpty(formData)) return {};
    const formSchema = inspection && inspection.formSchema ? formSchemas[inspection.formSchema] : {};
    const uiSchema = uiSchemas[inspection.formSchema] || {};
    const validatorSchema = validatorSchemas[inspection.formSchema] || {};
    const { _id = null, createdBy = undefined } = formData;
    const {
      formStatus = undefined,
      imageFileExtension = undefined,
      imageOriginalPrefix = undefined,
      imagePath = undefined,
      imageThumbnailPrefix = undefined,
      serverTime = undefined,
      costEstimate = {
        sellerCostEstimate: undefined,
        departmentCostEstimate: undefined,
      },
      signedAt = undefined,
      signedBy = undefined,
    } = inspection;
    const formContext = {
      _id,
      createdBy,
      formStatus,
      imageFileExtension,
      imageOriginalPrefix,
      imagePath,
      imageThumbnailPrefix,
      serverTime,
      costEstimate,
      signedAt,
      signedBy,
    };
    return {
      ...inspection,
      formContext,
      formData,
      formSchema,
      uiSchema,
      validatorSchema,
    };
  }
);

export const getAvailableFilters = createSelector([availableFilters], data => {
  return data.filters;
});



// WEBPACK FOOTER //
// ./src/modules/inspection/inspection.selectors.js